"use client";

import type React from "react";
import { useState } from "react";
import { Button, InputField } from "@/ui";

export interface FooterNewsletterProps {
  title: string;
  description: string;
  placeholder: string;
  buttonText: string;
}

const FooterNewsletter: React.FC<FooterNewsletterProps> = ({
  title,
  description,
  placeholder,
  buttonText,
}) => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle newsletter subscription
    console.log("Newsletter subscription:", email);
    setEmail("");
  };

  return (
    <div className="mb-20">
      <div className="max-w-2xl mx-auto text-center">
        <h3 className="text-3xl font-light text-black mb-6 tracking-wide">
          {title}
        </h3>
        <p className="text-lg text-black/60 mb-8 font-light">{description}</p>

        {/* Minimal Newsletter Form */}
        <form onSubmit={handleSubmit} className="relative">
          <InputField
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={placeholder}
            required
            className="w-full px-6 py-4 border border-black/20 bg-transparent text-black placeholder-black/40 focus:outline-none focus:border-black/40 transition-colors text-center tracking-wide pr-32"
          />
          <Button
            type="submit"
            variant="primary"
            className="absolute right-0 top-0 h-full px-8 bg-black text-white hover:bg-black/90 transition-colors tracking-wide rounded-none"
          >
            {buttonText}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default FooterNewsletter;
